<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">O<span class="smallcaps">NE</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// strangeloyalties_00001.vue?414d246a